import randomseed from 'random-seed';
import store from '@/store';

export default {
  getAvatar(user) {
    if (user && (user.avatar == null || Object.keys(user.avatar).length <= 0)) {
      // generate random id based on userId
      const avatarCount = store.state.defaultAvatars.length;
      const rand = randomseed.create(user.id);
      const randId = rand(avatarCount);

      if (store.state.defaultAvatars.length <= 0) {
        store.dispatch('getDefaultAvatars')
          .then(() => `${store.state.defaultAvatars[randId].image.thumb}`);
      } else {
        return `${store.state.defaultAvatars[randId].image.thumb}`;
      }
    }

    if (user && user.avatar !== null) {
      return `${user.avatar.thumb}`;
    }
    return '';
  },
  seededRandom(max, min, seed) {
    const rnd = seed / 233280;

    return min + rnd * (max - min);
  },
};
